export default "__VITE_ASSET__ob1vFUuL__"